import {Organization} from '../types';

import {
    useCreateOrganizationMutation,
    useDeleteOrganizationMutation,
    useOrganizationQuery,
    useUpdateOrganizationMutation,
} from './useOrganizationsQuery';

// FNP-948: the single record comes from React Query. Return shape unchanged so
// the pages and forms consuming this hook did not change.
export const useOrganization = (organizationId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useOrganizationQuery(organizationId);

    const createMutation = useCreateOrganizationMutation();
    const updateMutation = useUpdateOrganizationMutation();
    const deleteMutation = useDeleteOrganizationMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE, DELETE
    const createRecord = (values: Organization) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: Organization) => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }

        updateMutation.mutate({
            id: organizationId,
            record: values,
        });
    };

    const deleteRecord = () => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        deleteMutation.mutate(organizationId);
    };

    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
